export class TreasuryPostingRequestContractError extends Error {
  constructor(operation, detail) {
    super(`Invalid Treasury ${operation} request: ${detail}`);
    this.name = 'TreasuryPostingRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}

const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const decimal = value => typeof value === 'number'
  || typeof value === 'string' && /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(value.trim());
const amount = value => decimal(value) ? Number(value) : NaN;

/** Keep the caller's decimal representation and idempotency key unchanged. */
export function readTreasuryPostingRequest(payload, operation) {
  const value = operation === 'set_balance' ? amount(payload?.balance) : amount(payload?.amount);
  const validValue = operation === 'set_balance' ? value >= 0 : operation === 'add' ? value > 0 : value !== 0;
  if (!isRecord(payload) || !['add', 'transaction', 'set_balance'].includes(operation)
    || !Number.isFinite(value) || !validValue) {
    throw new TreasuryPostingRequestContractError(operation, 'expected a valid decimal amount for this posting.');
  }
  if ((payload.note !== undefined && payload.note !== null && typeof payload.note !== 'string')
    || (payload.requestId !== undefined && (typeof payload.requestId !== 'string'
      || !/^[a-zA-Z0-9_-]{8,128}$/.test(payload.requestId)))) {
    throw new TreasuryPostingRequestContractError(operation, 'expected a string note and optional valid requestId.');
  }
  return payload;
}
